export const roomCleaningColumns = [
    {
      Header: 'Id',
      accessor: 'Id',
    },
    {
      Header: 'Emp Name',
      accessor: 'empName',
    },
    {
      Header: 'Room Number',
      accessor: 'roomNumber',
    },
    {
      Header: 'Date',
      accessor: 'date',
    },
    {
      Header: 'Status',
      accessor: 'status',
    },
    {
      Header: 'Actions',
      accessor: 'actions',
    }
];

export const roomCleaningTableData = [
    {
    "Id": "01",
    "empName": "Jone",
    "roomNumber": "B-1202",
    "date": "22/01/2024",
    "status": "Under Progress"
    },
    {
    "Id": "02",
    "empName": "Meeta",
    "roomNumber": "C-1202",
    "date": "21/01/2024",
    "status": "Under Progress"
    },
    {
    "Id": "03",
    "empName": "Joshef",
    "roomNumber": "D-1202",
    "date": "22/01/2024",
    "status": "Under Progress"
    },
    {
    "Id": "04",
    "empName": "Roj",
    "roomNumber": "E-1202",
    "date": "19/01/2024",
    "status": "Under Progress"
    },
    {
    "Id": "05",
    "empName": "Jone",
    "roomNumber": "H-1101",
    "date": "18/01/2024",
    "status": "Under Progress"
    },
    {
      "Id": "06",
      "empName": "Risha",
      "roomNumber": "G-1108",
      "date": "18/01/2024",
      "status": "Under Progress"
    },
    {
      "Id": "07",
      "empName": "Roma",
      "roomNumber": "K-1308",
      "date": "05/03/2024",
      "status": "Under Progress"
    },
    {
      "Id": "08",
      "empName": "Lina",
      "roomNumber": "L-1408",
      "date": "08/03/2024",
      "status": "Under Progress"
    },
    {
      "Id": "09",
      "empName": "Micky",
      "roomNumber": "L-1405",
      "date": "08/03/2024",
      "status": "Under Progress"
    },
]

  